if (!customElements.get('shipping-message')) {
  customElements.define(
    'shipping-message',
    class ShippingMessage extends HTMLElement {
      constructor() {
        super();
        this.unsubscriber = null;
      }

      connectedCallback() {
        // Subscribe to variant change events
        this.unsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );

        // Get initial data
        this.productMessage = this.dataset.productMessage || '';
        this.variantMessages = this.parseVariantMessages();
        this.hideWhenSoldOut = this.dataset.hideWhenSoldOut === 'true';
        this.color = this.dataset.color || '#00be6c';
        this.icon = this.dataset.icon || '✔';

        // Get initial variant from product-info or variant-selects
        const productInfo = document.querySelector('product-info');
        if (productInfo) {
          const variantInput = productInfo.querySelector('input[name="id"]');
          if (variantInput) {
            const variantId = variantInput.value;
            const variant = this.getVariantById(variantId);
            this.updateMessage(variant);
          }
        }
      }

      disconnectedCallback() {
        // Clean up subscription when element is removed
        if (this.unsubscriber) {
          this.unsubscriber();
        }
      }

      parseVariantMessages() {
        try {
          const messages = this.dataset.variantMessages;
          return messages ? JSON.parse(messages) : {};
        } catch (error) {
          console.error('Error parsing variant messages:', error);
          return {};
        }
      }

      getVariantById(variantId) {
        // Try to get variant data from window.productVariants if available
        if (window.productVariants) {
          return window.productVariants.find(v => v.id == variantId);
        }
        return null;
      }

      handleVariantChange(event) {
        const { variant } = event.data;
        this.updateMessage(variant);
      }

      updateMessage(variant) {
        // Priority 1: If variant is sold out and hideWhenSoldOut is true, hide message
        if (this.hideWhenSoldOut && variant && variant.available === false) {
          this.innerHTML = '';
          return;
        }

        let message = '';

        // Priority 2: Check variant-specific metafield message
        if (variant && variant.id && this.variantMessages[variant.id]) {
          message = this.variantMessages[variant.id];
        }
        // Priority 3: Check product metafield fallback
        else if (this.productMessage) {
          message = this.productMessage;
        }

        // Update the DOM
        if (message) {
          this.innerHTML = `
            <div class="shipping-message-content" style="color: ${this.color};">
              ${this.icon} ${message}
            </div>
          `;
        } else {
          this.innerHTML = '';
        }
      }
    }
  );
}
